import { render, staticRenderFns } from "./PreviousDeployments.vue?vue&type=template&id=d46e4fa4&"
import script from "./PreviousDeployments.vue?vue&type=script&lang=ts&"
export * from "./PreviousDeployments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports